import { render } from "./Textblock.vue?vue&type=template&id=466e6d55"
import script from "./Textblock.vue?vue&type=script&lang=js"
export * from "./Textblock.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__